/**
 * Deep-link builder for prefilled Linear "new issue" URLs.
 *
 * Linear's new-issue route accepts the issue fields as query params, e.g.
 * .../new?title=Foo&assignee=matthew&priority=0&status=Todo&labels=Component%20library
 */

const LINEAR_NEW_ISSUE_URL = 'https://linear.app/splits/team/PE/new'

type LinearIssueParams = {
  title?: string
  description?: string
  assignee?: string
  priority?: number
  status?: string
  cycle?: string
  /** A single label or a list of labels (joined with commas for Linear). */
  labels?: string | string[]
}

export const buildLinearIssueUrl = (params: LinearIssueParams): string => {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== '')
    .map(([key, value]) => {
      const formatted = Array.isArray(value) ? value.join(',') : String(value)
      return key + '=' + encodeURIComponent(formatted)
    })
    .join('&')

  return query ? LINEAR_NEW_ISSUE_URL + '?' + query : LINEAR_NEW_ISSUE_URL
}
